export const NCAAF_LEAGUES = [
  {
    id: 2,
    name: "NCAAF",
    country: "USA",
    flag: "🇺🇸"
  }
];
